import React from 'react';
import AppAnnieIcon from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import SensorTowerIcon from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import DataBrainIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-bg.svg';
import { datamapIntelligenceMetricsPath } from '@/pages/intelligence/utils/common';
import { useIntl, history } from 'umi';

//校准
export default function DatabrainBubbleTip() {
  const { formatMessage } = useIntl(); // 中英切换方法
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      style={{ lineHeight: '18px' }}
    >
      <p>
        <img className="tips-icon" src={DataBrainIcon}></img>
        <span>{formatMessage({ id: 'dbi_metric_databrain_info1' })}</span>
        <img className="tips-icon" src={AppAnnieIcon}></img> data.ai &{' '}
        <img className="tips-icon" src={SensorTowerIcon}></img> Sensor Tower
      </p>
      <span>{formatMessage({ id: 'dbi_metric_databrain_info' })}</span>
      <span
        style={{ color: '#326FF0', cursor: 'pointer', paddingLeft: '5px' }}
        onClick={() => {
          history.push({
            pathname: datamapIntelligenceMetricsPath,
            query: {
              pageid: 'databarin',
            },
          });
        }}
      >
        {formatMessage({ id: 'dbh_learnmore', })}
      </span>
    </div>
  );
}
